import { IonCol, IonRow, IonSkeletonText, withIonLifeCycle } from "@ionic/react";
import React from "react";
import { withTranslation } from "react-i18next";

class ArticleSkeleton extends React.Component<any, any> {
  render() {
    return (
      <div className="wrapper">
        <IonRow className="news-view__header ion-align-items-center ion-hide-md-down">
          <IonCol size="12" size-lg="8" className="ion-justify-content-start">
            <h1>
              <IonSkeletonText animated style={{ width: "50%", height: "2rem" }} />
            </h1>
          </IonCol>
        </IonRow>

        <IonSkeletonText animated style={{ width: "100%", height: this.props.imageHeight || "300px", margin: 0 }} />

        <IonRow className="news-view__body-wrap">
          <IonCol className="news-view__body-sidebar ion-hide-md-down" size-md="3">
            <p className="heading heading--label">
              <IonSkeletonText animated style={{ width: "50%" }} />
            </p>

            <div className="wysiwyg-content wysiwyg-content--news-view">
              <p>
                <IonSkeletonText animated style={{ width: "90%" }} />
              </p>
              <p>
                <IonSkeletonText animated style={{ width: "80%" }} />
              </p>
              <p>
                <IonSkeletonText animated style={{ width: "90%" }} />
              </p>
              <p>
                <IonSkeletonText animated style={{ width: "85%" }} />
              </p>
            </div>
          </IonCol>

          <IonCol className="news-view__body-content" size="12" size-md="7" offset-md="2">
            <h1 className="ion-hide-md-up">
              <IonSkeletonText animated style={{ width: "50%", height: "2rem" }} />
            </h1>

            <div className="wysiwyg-content wysiwyg-content--news-view">
              <p>
                <IonSkeletonText animated style={{ width: "90%" }} />
              </p>
              {this.props.excerptOnly ? (
                ""
              ) : (
                <>
                  <p>
                    <IonSkeletonText animated style={{ width: "80%" }} />
                  </p>
                  <p>
                    <IonSkeletonText animated style={{ width: "90%" }} />
                  </p>
                  <p>
                    <IonSkeletonText animated style={{ width: "85%" }} />
                  </p>
                </>
              )}
            </div>
          </IonCol>
        </IonRow>
      </div>
    );
  }
}

const firstHoc = withIonLifeCycle(ArticleSkeleton);
export default withTranslation()(firstHoc);
